import {Typography} from "@mui/material";

export const StakeholderListInfoContent = () => {


    return {
        title: 'Stakeholder Lists',
        content: (
            <>
                <Typography paragraph>
                    Stakeholder Lists are used to define the participants
                    associated with a product and to automate the creation
                    of contracts and contractual relationships within the
                    system.
                </Typography>

                <ul>
                    <li>
                        A Stakeholder List identifies the individuals,
                        companies, or other entities that have a contractual
                        interest in a product.
                    </li>

                    <li>
                        Stakeholder Lists are commonly used when onboarding
                        new products or when establishing the initial set
                        of contracts required for administration.
                    </li>

                    <li>
                        Each Stakeholder List may contain one or many
                        stakeholders, along with the information needed
                        to create their contracts.
                    </li>

                    <li>
                        Stakeholder Lists help reduce manual data entry
                        by allowing contracts to be generated automatically
                        from predefined stakeholder information.
                    </li>

                    <li>
                        Use the <strong>Search</strong> (magnifying glass)
                        to locate existing Stakeholder Lists.
                    </li>

                    <li>
                        Use the <strong>Upload</strong> button to import
                        Stakeholder List data from external files.
                    </li>

                    <li>
                        Use the <strong>Add</strong> (+) button to create
                        a new Stakeholder List manually.
                    </li>

                    <li>
                        Use the row menu on the left side of the grid
                        to clone, edit, or delete Stakeholder Lists.
                    </li>

                    <li>
                        Files can also be <strong>Processed</strong> from
                        this screen to automatically create new contracts
                        and related records based on the Stakeholder List
                        data provided.
                    </li>

                    <li>
                        Maintaining accurate Stakeholder Lists helps ensure
                        that contract creation is consistent, complete,
                        and aligned with the parties entitled to receive
                        obligations, payments, or other contractual rights.
                    </li>
                </ul>
            </>
        )
    };

};







